import { gql } from '@apollo/client'
import { MUTATION_STATE } from 'api/fragments'

const PAYLOAD_TYPE = 'UpdateCampaignPayload'

export const UPDATE_CAMPAIGN = gql`
    ${MUTATION_STATE(PAYLOAD_TYPE)}
    mutation updateCampaign(
        $id: ID!
        $agencyId: ID
        $advertiserId: ID,
        $name: String
        $briefName: String
        $startDate: ISO8601DateTime
        $endDate: ISO8601DateTime
        $supervisors: [ID!]
        $commercialSupervisorId: ID
        $ordererId: ID
        $departmentId: ID
        $broadsignTotalOutdoor: String
        $agencyDiscount: String
        $campaignTagList: [String!]
    ) {
        updateCampaign(
            input: {
                id: $id
                agencyId: $agencyId
                advertiserId: $advertiserId
                name: $name
                briefName: $briefName
                startDate: $startDate
                endDate: $endDate
                supervisors: $supervisors
                commercialSupervisorId: $commercialSupervisorId
                ordererId: $ordererId
                departmentId: $departmentId
                broadsignTotalOutdoor: $broadsignTotalOutdoor
                agencyDiscount: $agencyDiscount
                campaignTagList: $campaignTagList
            }
        ) {
            campaign {
                id
                brainState
                supervisors {
                    id
                    firstName
                    lastName
                }
                agency {
                    allowedTargets {
                        id
                        name
                    }
                }
                commercialSupervisor {
                    id
                }
                orderer {
                    id
                }
                department {
                    id
                }
                broadsignTotalOutdoor
                agencyDiscount
                campaignTagList
            }
            ...MutationState${PAYLOAD_TYPE}Fields
        }
    }
`
